<mat-card class="table-card" appCard>
    <mat-card-content>

        <table mat-table   style="width: 100% ;" [dataSource]="dataSource" class="mat-elevation-z8 table-card">


            <ng-container
                    *ngFor="let column of readColumns let i = index;  first as first;"
                    [matColumnDef]="column"
            >
                <th mat-header-cell *matHeaderCellDef style="text-align: center ;font-size: 17px">
                    {{ labels[column] | translate }}
                </th>
    
    
                <td mat-cell *matCellDef="let type" style="text-align: center">
                    {{ type[column] | typedValue | async | translate }}
                </td>
    
            </ng-container>
    

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    
    

    <!-- Copyright 2018 Google Inc. All Rights Reserved.
        Use of this source code is governed by an MIT-style license that
        can be found in the LICENSE file at http://angular.io/license -->
    
        <app-empty-list-container  [withoutBorder]="true" [list]="dataSource.data">  </app-empty-list-container>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </mat-card-content>


</mat-card>
                        
                       